import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/ProductsTR/';

export default {
  getProductTRList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveProductTR: data => post(`${defaultUrl}`, data),
};
